


export function validateClientName(name) {
    let formatName;

    if (!name) {
        return false;
    }

    formatName = name.split(' ');

    let valid = false;

    if(formatName && formatName.length > 1 && formatName[0].length > 1) {
        if(formatName[formatName.length - 1].length > 1){
            valid = true;
    
        } else if (formatName[formatName.length - 1].length == 0 && formatName.length > 2) {
            valid = true;
    
        } else {
            valid = false;
        }

    }

    return valid;
}